'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _surveyValidation = require('./surveyValidation');

var _surveyValidation2 = _interopRequireDefault(_surveyValidation);

var _survey = require('redux/modules/survey');

var surveyActions = _interopRequireWildcard(_survey);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncValidate(data, dispatch, _ref) {
  var isValidEmail = _ref.isValidEmail;

  if (!data.email) {
    return _promise2.default.resolve({});
  }
  return isValidEmail(data);
}
var SurveyForm = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(surveyActions, dispatch);
}), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'survey',
  fields: ['name', 'email', 'occupation', 'currentlyEmployed', 'sex'],
  validate: _surveyValidation2.default,
  asyncValidate: asyncValidate,
  asyncBlurFields: ['email']
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyForm, _Component);

  function SurveyForm() {
    (0, _classCallCheck3.default)(this, SurveyForm);
    return (0, _possibleConstructorReturn3.default)(this, (SurveyForm.__proto__ || (0, _getPrototypeOf2.default)(SurveyForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(SurveyForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          asyncValidating = _props.asyncValidating,
          dirty = _props.dirty,
          _props$fields = _props.fields,
          name = _props$fields.name,
          email = _props$fields.email,
          occupation = _props$fields.occupation,
          currentlyEmployed = _props$fields.currentlyEmployed,
          sex = _props$fields.sex,
          active = _props.active,
          handleSubmit = _props.handleSubmit,
          invalid = _props.invalid,
          resetForm = _props.resetForm,
          pristine = _props.pristine,
          valid = _props.valid;

      var styles = require('./SurveyForm.scss');
      var renderInput = function renderInput(field, label, showAsyncValidating) {
        return _react2.default.createElement(
          'div',
          { className: 'form-group' + (field.error && field.touched ? ' has-error' : '') },
          _react2.default.createElement(
            'label',
            { htmlFor: field.name, className: 'col-sm-2' },
            label
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-8 ' + styles.inputGroup },
            showAsyncValidating && asyncValidating && _react2.default.createElement('i', { className: 'fa fa-cog fa-spin ' + styles.cog }),
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'text', className: 'form-control', id: field.name }, field)),
            field.error && field.touched && _react2.default.createElement(
              'div',
              { className: 'text-danger' },
              field.error
            ),
            _react2.default.createElement(
              'div',
              { className: styles.flags },
              field.dirty && _react2.default.createElement(
                'span',
                { className: styles.dirty, title: 'Dirty' },
                'D'
              ),
              field.active && _react2.default.createElement(
                'span',
                { className: styles.active, title: 'Active' },
                'A'
              ),
              field.visited && _react2.default.createElement(
                'span',
                { className: styles.visited, title: 'Visited' },
                'V'
              ),
              field.touched && _react2.default.createElement(
                'span',
                { className: styles.touched, title: 'Touched' },
                'T'
              )
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal', onSubmit: handleSubmit },
          renderInput(name, 'Full Name'),
          renderInput(email, 'Email', true),
          renderInput(occupation, 'Occupation'),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { htmlFor: 'currentlyEmployed', className: 'col-sm-2' },
              'Currently Employed?'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-8' },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox', id: 'currentlyEmployed' }, currentlyEmployed))
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'col-sm-2' },
              'Sex'
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-sm-8' },
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'sex-male' }, sex, { value: 'male', checked: sex.value === 'male' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'sex-male', className: styles.radioLabel },
                'Male'
              ),
              _react2.default.createElement('input', (0, _extends3.default)({ type: 'radio', id: 'sex-female' }, sex, { value: 'female', checked: sex.value === 'female' })),
              _react2.default.createElement(
                'label',
                { htmlFor: 'sex-female', className: styles.radioLabel },
                'Female'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-offset-2 col-sm-10' },
              _react2.default.createElement(
                'button',
                { className: 'btn btn-success', onClick: handleSubmit },
                _react2.default.createElement('i', { className: 'fa fa-paper-plane' }),
                ' Submit'
              ),
              _react2.default.createElement(
                'button',
                { className: 'btn btn-warning', onClick: resetForm, style: { marginLeft: 15 } },
                _react2.default.createElement('i', { className: 'fa fa-undo' }),
                ' Reset'
              )
            )
          )
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Props from redux-form'
        ),
        _react2.default.createElement(
          'table',
          { className: 'table table-striped' },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Active Field'
              ),
              _react2.default.createElement(
                'td',
                null,
                active
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Dirty'
              ),
              _react2.default.createElement(
                'td',
                { className: dirty ? 'success' : 'danger' },
                dirty ? 'true' : 'false'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Pristine'
              ),
              _react2.default.createElement(
                'td',
                { className: pristine ? 'success' : 'danger' },
                pristine ? 'true' : 'false'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Valid'
              ),
              _react2.default.createElement(
                'td',
                { className: valid ? 'success' : 'danger' },
                valid ? 'true' : 'false'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Invalid'
              ),
              _react2.default.createElement(
                'td',
                { className: invalid ? 'success' : 'danger' },
                invalid ? 'true' : 'false'
              )
            )
          )
        )
      );
    }
  }]);
  return SurveyForm;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired
}, _temp)) || _class) || _class);
exports.default = SurveyForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyForm/SurveyForm.js
// module id = 1509
// module chunks = 0